import { SearchspringUiRenderer } from '../helpers/searchspring_ui_renderer'
import {
  RecommendRequestModel,
  RecommendCombinedResponseModel,
} from '@searchspring/snap-client'
import BaseSearchSpringController from './base_searchspring_controller'
import { SearchspringProduct } from '../types/searchspring'

export default class PdpSearchspringPersonalizationController extends BaseSearchSpringController {
  static targets = ['products']
  static values = {
    tag: { type: String, default: 'shop-similar' },
    limit: { type: Number, default: 4 },
    productId: { type: String, default: '' },
  }

  declare readonly productsTarget: HTMLElement
  declare readonly hasProductsTarget: boolean
  declare tagValue: string
  declare limitValue: number
  declare productIdValue: string

  async connect(): Promise<void> {
    await this.fetchRecommendations()
  }

  async fetchRecommendations(): Promise<void> {
    const request: RecommendRequestModel = {
      tag: this.tagValue,
      limit: this.limitValue,
      products: this.productIdValue ? [this.productIdValue] : [],
      batched: true,
    }

    try {
      const response = await this.client.recommend(
        request as Parameters<typeof this.client.recommend>[0],
      )
      const profile = response as unknown as RecommendCombinedResponseModel

      if (!profile || !profile.results || profile.results.length === 0) {
        this.renderEmpty()
        return
      }

      this.render(profile)
    } catch (error) {
      console.error(
        '[PdpSearchspringPersonalizationController] Failed to fetch recommendations:',
        error,
      )
      this.renderError()
    }
  }

  render(profile: RecommendCombinedResponseModel): void {
    if (!this.hasProductsTarget) return

    this.productsTarget.innerHTML = SearchspringUiRenderer.renderProducts(
      (profile.results as unknown as SearchspringProduct[]) || [],
    )
  }

  renderEmpty(): void {
    if (!this.hasProductsTarget) return

    this.productsTarget.innerHTML = '<p>No recommendations available.</p>'
  }

  renderError(): void {
    if (!this.hasProductsTarget) return

    this.productsTarget.innerHTML = '<p>Unable to find recommendations.</p>'
  }
}
